import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

const UpdateVitalsModal = (props) => {
    return (
        <div>
            <Modal show={props.show} onHide={props.close} centered className="add_report_modal">
                <Modal.Header closeButton>
                    <Modal.Title>Update Vitals</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="report_details_form">
                        <Form>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form_group" controlId="heartBeat">
                                        <Form.Label>Heartbeat (BPM)<span>*</span></Form.Label>
                                        <Form.Control type="heartBeat" placeholder="Ex. 89bpm" />
                                    </Form.Group>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form_group" controlId="bloodPressure">
                                        <Form.Label>Blood Pressure (mm/hg)<span>*</span></Form.Label>
                                        <Row>
                                            <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                                <Form.Control type="bloodPressure" placeholder="Ex. 102" />
                                            </Col>
                                            <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                                <Form.Control type="bloodPressure" placeholder="Ex. 72" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <Form.Group className="form_group" controlId="temperature">
                                        <Form.Label>Temperature (Celsius)<span>*</span></Form.Label>
                                        <Form.Control type="temperature" placeholder="Ex. 80" />
                                    </Form.Group>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <Form.Group className="form_group" controlId="oxygenSaturation">
                                        <Form.Label>Oxygen Saturation (Spo2/Prbpm)<span>*</span></Form.Label>
                                        <Row>
                                            <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                                <Form.Control type="oxygenSaturation" placeholder="Ex. 97 SPo2" />
                                            </Col>
                                            <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                                <Form.Control type="oxygenSaturation" placeholder="Ex. 60PRbpm" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <Form.Group className="form_group" controlId="bloodSugar">
                                        <Form.Label>Blood Sugar (mg/dl)<span>*</span></Form.Label>
                                        <Form.Control type="bloodSugar" placeholder="Ex. 104mg/dl" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className="btn_area">
                                <Button className="cancelBtn" type="button" onClick={props.close}>Cancel</Button>
                                <Button className="submitBtn" type="submit">Update</Button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default UpdateVitalsModal;